import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { b as businessCoreInfoSchema } from './business-core-info-schema.js';
import { F as FormController } from './form.js';
import { C as CoreBusinessInfo } from './Business.js';
import { a as businessClassificationOptions } from './business-form-options.js';
import { P as PHONE_MASKS } from './form-input-masks.js';
import { n as numberOnlyHandler } from './utils4.js';
import { d as defineCustomElement$6 } from './form-control-date2.js';
import { d as defineCustomElement$5 } from './form-control-error-text2.js';
import { d as defineCustomElement$4 } from './form-control-help-text2.js';
import { d as defineCustomElement$3 } from './form-control-number-masked2.js';
import { d as defineCustomElement$2 } from './form-control-select2.js';
import { d as defineCustomElement$1 } from './form-control-text2.js';

const BusinessCoreInfoFormStepCore = /*@__PURE__*/ proxyCustomElement(class BusinessCoreInfoFormStepCore extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.submitted = createEvent(this, "submitted", 7);
        this.formLoading = createEvent(this, "formLoading", 7);
        this.errorEvent = createEvent(this, "error-event", 7);
        this.getData = () => {
            this.formLoading.emit(true);
            this.getBusiness({
                onSuccess: (response) => {
                    this.coreInfo = new CoreBusinessInfo(response.data);
                    this.formController.setInitialValues(Object.assign({}, this.coreInfo));
                },
                onError: ({ error, code, severity }) => {
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => this.formLoading.emit(false)
            });
        };
        this.sendData = (onSuccess) => {
            let submittedData;
            this.formLoading.emit(true);
            this.patchBusiness({
                payload: this.patchPayload,
                onSuccess: (response) => {
                    submittedData = response;
                    onSuccess();
                },
                onError: ({ error, code, severity }) => {
                    submittedData = error;
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => {
                    this.submitted.emit({ data: { submittedData } });
                    this.formLoading.emit(false);
                }
            });
        };
        this.inputHandler = (name, value) => {
            this.formController.setValues(Object.assign(Object.assign({}, this.formController.values.getValue()), { [name]: value }));
        };
        this.formController = undefined;
        this.errors = {};
        this.coreInfo = {};
        this.businessId = undefined;
        this.getBusiness = undefined;
        this.patchBusiness = undefined;
        this.allowOptionalFields = undefined;
    }
    async validateAndSubmit({ onSuccess }) {
        this.formController.validateAndSubmit(() => this.sendData(onSuccess));
    }
    ;
    get patchPayload() {
        let formValues = new CoreBusinessInfo(this.formController.values.getValue()).payload;
        return formValues;
    }
    componentWillLoad() {
        this.getBusiness && this.getData();
        this.formController = new FormController(businessCoreInfoSchema(this.allowOptionalFields));
    }
    componentDidLoad() {
        this.formController.errors.subscribe(errors => {
            this.errors = Object.assign({}, errors);
        });
    }
    render() {
        const coreInfoDefaultValue = this.formController.getInitialValues();
        return (h("form", { key: 'ab0ae9821e19c2a2d1e87ce16b23cfe56bafb31b' }, h("fieldset", { key: 'eec949b50436218cee02c6410c34959a6b10ebf8' }, h("legend", { key: '34b37dddcb967275ddd3d561dd2931b74103c0ce' }, "General Info"), h("hr", { key: 'af37f3171790265c3b7d22d2328c31842c5a12ea' }), h("div", { key: 'ba4780eec04a8b34f644895913e99ea49c587f81', class: 'row gy-3' }, h("div", { key: '8109ee7485afc5a5ee3e38c947ef9387cab5daa4', class: 'col-12' }, h("form-control-text", { key: '885bc9f67fc4738cb5abc6165bf1f6f5b3382a90', name: 'legal_name', label: 'Legal Name', defaultValue: coreInfoDefaultValue.legal_name, errorText: this.errors.legal_name, inputHandler: this.inputHandler })), h("div", { key: '453b4e25b812015a50f72e76159111818d0065f5', class: 'col-12' }, h("form-control-text", { key: 'a63ec6c1e936ab1104b92e6fdd5f6a350559009c', name: 'doing_business_as', label: 'Doing Business As (DBA)', defaultValue: coreInfoDefaultValue.doing_business_as, errorText: this.errors.doing_business_as, inputHandler: this.inputHandler })), h("div", { key: '8a39b25c7d9c414569e22e73a98d7b136b0623dd', class: 'col-12 col-md-8' }, h("form-control-select", { key: '41d6d3a45431953746e86a5aea6ebb0a39674009', name: 'classification', label: 'Business Classification', options: businessClassificationOptions, defaultValue: coreInfoDefaultValue.classification, errorText: this.errors.classification, inputHandler: this.inputHandler })), h("div", { key: 'd98e5f2ee6e7d3ddc23ba5501db4f698cc88ba40', class: 'col-12 col-md-4' }, h("form-control-date", { key: '4ea36622261e3a649b934700ee676c062789c519', name: 'date_of_incorporation', label: 'Date of Incorporation', defaultValue: coreInfoDefaultValue.date_of_incorporation, errorText: this.errors.date_of_incorporation, inputHandler: this.inputHandler })), h("div", { key: '8617887e16cbc3a40b0c1ab56597d7098c7ac62f', class: 'col-12 col-md-6' }, h("form-control-text", { key: '9357ddb686194100fe705111bbc965c2956dddb4', name: 'industry', label: 'Industry', defaultValue: coreInfoDefaultValue.industry, errorText: this.errors.industry, inputHandler: this.inputHandler })), h("div", { key: '968b0f492f354279736b531295a1e4813a5de0b0', class: 'col-12 col-md-6' }, h("form-control-text", { key: 'd082445d9f876794e525839fb35457f114e89dac', name: 'tax_id', label: 'Tax ID (EIN or SSN)', defaultValue: coreInfoDefaultValue.tax_id, errorText: this.errors.tax_id, inputHandler: this.inputHandler, keyDownHandler: numberOnlyHandler, maxLength: 9 })), h("div", { key: 'a0e041bb3fa323e378d2b9730dd9055c9ecf1dfc', class: 'col-12' }, h("form-control-text", { key: '4994efe8c6cb5faf84accd0f2965b508d084144e', name: 'website_url', label: 'Website URL', defaultValue: coreInfoDefaultValue.website_url, errorText: this.errors.website_url, inputHandler: this.inputHandler })), h("div", { key: '0f7f1548e704095aaef9d4fccd7c81284ff7bbed', class: 'col-12 col-md-6' }, h("form-control-text", { key: 'e1cffd24b03e5e3655649b68900c74fcc89513c5', name: 'email', label: 'Email Address', defaultValue: coreInfoDefaultValue.email, errorText: this.errors.email, inputHandler: this.inputHandler })), h("div", { key: '1732635477c58d1f57aa5b8dc0c560ae0c215501', class: 'col-12 col-md-6' }, h("form-control-number-masked", { key: '04979d08463efc69557b782fda772702935349a7', name: 'phone', label: 'Phone Number', defaultValue: coreInfoDefaultValue.phone, errorText: this.errors.phone, inputHandler: this.inputHandler, mask: PHONE_MASKS.US }))))));
    }
}, [0, "justifi-business-core-info-form-step-core", {
        "businessId": [1, "business-id"],
        "getBusiness": [16],
        "patchBusiness": [16],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "formController": [32],
        "errors": [32],
        "coreInfo": [32],
        "validateAndSubmit": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-business-core-info-form-step-core", "form-control-date", "form-control-error-text", "form-control-help-text", "form-control-number-masked", "form-control-select", "form-control-text"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-business-core-info-form-step-core":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessCoreInfoFormStepCore);
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessCoreInfoFormStepCore as B, defineCustomElement as d };
